const createCoords = (width, height) => {
  // Create coordinates for the four quadrants of the video frame
  const quarterWidth = width / 4;
  const quarterHeight = height / 4;
  const threeQuarterWidth = (width * 3) / 4;
  const threeQuarterHeight = (height * 3) / 4;

  return [
    [quarterWidth, quarterHeight],
    [quarterWidth, threeQuarterHeight],
    [threeQuarterWidth, quarterHeight],
    [threeQuarterWidth, threeQuarterHeight],
  ];
};

const black = { r: 0, g: 0, b: 0 };

const isWithinTolerance = (real, expected, tolerance) =>
  Math.abs(real - expected) <= tolerance;

// Note: For an input e.g. rgb(34, 167, 240), but due to browser processing
// output is ~rgb(47, 176, 235) and can depend on browser as well as
// publisher vs subscriber, so we allow a tolerance of 20.
const rgbTolerance = 20;

const isPixelColor = (pixel, expectedRGB) => {
  const [r, g, b] = pixel.data;
  return (
    isWithinTolerance(r, expectedRGB.r, rgbTolerance) &&
    isWithinTolerance(g, expectedRGB.g, rgbTolerance) &&
    isWithinTolerance(b, expectedRGB.b, rgbTolerance)
  );
};

const isVideoFrameBlack = (videoElement) => {
  const coords = createCoords(
    videoElement.videoWidth,
    videoElement.videoHeight
  );

  const canvas = document.createElement('canvas');
  canvas.width = videoElement.videoWidth;
  canvas.height = videoElement.videoHeight;

  const ctx = canvas.getContext('2d');
  ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

  const hasBlackVideoFrame = coords.every(([x, y]) =>
    isPixelColor(ctx.getImageData(x, y, 1, 1), black));

  canvas.remove();

  return hasBlackVideoFrame;
};

export default isVideoFrameBlack;
